import { getDeviceType } from "../utils/deviceDetection";

export function isSafariOnMac() {
  const userAgent = navigator.userAgent;
  const isSafari = /Safari/.test(userAgent) && !/Chrome/.test(userAgent);
  const isMac = /Mac/.test(navigator.platform) || /Macintosh/.test(userAgent);
  return isSafari && isMac;
}

export function isSafariOnDesktopMac() {
  return isSafariOnMac() && navigator.maxTouchPoints <= 1;
}

const isTouchDevice = navigator.maxTouchPoints > 0;

export const isTablet =
  getDeviceType() === "Tablet" ||
  (isTouchDevice && getDeviceType() === "Desktop");

export const isTabletLandscape =
  isTablet && window.innerWidth > window.innerHeight;

export const PRODUCT_ID = "aaa";

export const APP_VERSION = import.meta.env.VITE_BUILD_VERSION || "1.0";
